import { render, staticRenderFns } from "./ModalCarregadosOntemInfo.vue?vue&type=template&id=456fdd15"
import script from "./ModalCarregadosOntemInfo.vue?vue&type=script&lang=js"
export * from "./ModalCarregadosOntemInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports